import axios from "@common/api/desktop/axios";
import { mapToSelect } from "./egm";

class Revenue {
  getCategories = async () => {
    return [
      { key: "ALL", value: -1, text: "All" },
      { key: "1", value: 1, text: "Category 1" },
      { key: "2", value: 2, text: "Category 2" },
    ];
  };

  getSummary = async (
    operatorId,
    company,
    subCompany,
    weeks,
    categoryId,
    dataView,
    groupBy,
    regionId,
  ) => {
    const response = await axios.get(
      `revenue/dashboard/${operatorId},${company ?? -1},${subCompany ?? -1},${weeks},${categoryId},${dataView},${groupBy},${regionId}`,
    );
    return response.data;
  };

  getGraph = async (
    operatorId,
    company,
    subCompany,
    groupId,
    weeks,
    categoryId,
    reportType,
    varianceType,
    groupBy,
    regionId,
  ) => {
    const response = await axios.get(
      `revenue/revenue/dashboard/graph/${operatorId},${company ?? -1},${subCompany ?? -1},${groupId},${weeks},${categoryId},${reportType},${varianceType},${groupBy},${regionId}`,
    );
    return response.data;
  };

  getIncomeSummary = async (
    operatorId,
    weeks,
    categoryId,
    dataView,
    varianceType,
    groupBy,
    regionId,
  ) => {
    const response = await axios.get(
      `incomesecurity/dashboard/${operatorId},${weeks},${categoryId},${dataView},${varianceType},${groupBy},${regionId}`,
    );
    return response.data;
  };

  getIncomeSummaryExport = async (
    operatorId,
    weeks,
    categoryId,
    dataView,
    varianceType,
    groupBy,
    regionId,
  ) => {
    return await axios.get(
      `incomesecurity/export/${operatorId},${weeks},${categoryId},${dataView},${varianceType},${groupBy},${regionId}`,
      { responseType: "arraybuffer" },
    );
  };

  getIncomeGraph = async (
    groupId,
    weeks,
    categoryId,
    reportType,
    varianceType,
    groupBy,
    regionId,
  ) => {
    const response = await axios.get(
      `incomesecurity/incomesecurity/dashboard/graph/${groupId},${weeks},${categoryId},${reportType},${varianceType},${groupBy},${regionId}`,
    );
    return response.data;
  };

  getRevenueSummaryExport = async (
    operatorId,
    companyId,
    subCompanyId,
    weeks,
    categoryId,
    reportType,
    groupBy,
    regionId,
  ) => {
    return await axios.get(
      `revenue/export/${operatorId},${companyId ?? -1},${subCompanyId ?? -1},${weeks},${categoryId},${reportType},${groupBy},${regionId}`,
      { responseType: "arraybuffer" },
    );
  };

  getRevenueViewTypes = async () => {
    const response = await axios.get(`revenue/options/dataview`);
    return mapToSelect(response.data);
  };

  getRevenueGraphOptions = async (dataView) => {
    const response = await axios.get(
      `revenue/options/dataviewgraph/${dataView}`,
    );
    return mapToSelect(response.data);
  };

  getIncomeGraphOptions = async (dataView) => {
    const response = await axios.get(
      `incomesecurity/options/dataviewgraph/${dataView}`,
    );
    return mapToSelect(response.data);
  };

  getIncomeSecurityViewTypes = async () => {
    const response = await axios.get(`incomesecurity/options/dataview`);
    return mapToSelect(response.data);
  };

  getRegions = async (operatorId) => {
    const response = await axios.get(
      `organisation/operatorregions/all/${operatorId}`,
    );
    return mapToSelect(response.data);
  };

  getCompanies = async (operatorId) => {
    const response = await axios.get(`revenue/operator/company/${operatorId}`);
    return mapToSelect(response.data);
  };

  getSubCompanies = async (companyId) => {
    const response = await axios.get(`revenue/company/subcompany/${companyId}`);
    return mapToSelect(response.data);
  };
}
const revenue = new Revenue();
export default revenue;
